import { useCallback } from "react";
import { ImageBackground } from "react-native";

import { Col, TextBody } from "../lib";
import {
  Attention,
  getDateFromServerTimestamp,
  useUserStatusDelete,
} from "../services";
import { colors, createStyles } from "../theme";
import { TimelineListItemFooter } from "./timeline-list-item-footer";

type Props = {
  approved: boolean;
  createdAt: number;
  id: number;
  imageUrl: string;
  onDelete: () => void;
  text: string;
};

export function StatusListItem({
  approved,
  createdAt,
  id,
  imageUrl,
  onDelete,
  text,
}: Props) {
  const [deleteStatus] = useUserStatusDelete({ id });

  // Handlers

  const handleDelete = useCallback(async () => {
    const ok = await Attention.confirm(
      "Delete Status",
      "Are you sure you want to delete this picture?",
      { destructive: true },
    );

    if (ok) {
      debugger;
      await deleteStatus();

      onDelete();
    }
  }, [deleteStatus, onDelete]);

  return (
    <Col m="4" style={$.container}>
      <ImageBackground
        source={{ uri: imageUrl }}
        resizeMode="cover"
        style={$.image}
      />

      <TimelineListItemFooter
        createdAt={getDateFromServerTimestamp(createdAt)}
        published={approved}
        onDelete={handleDelete}
        variant="image"
      >
        <TextBody>{text}</TextBody>
      </TimelineListItemFooter>
    </Col>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "surface",
    borderRadius: "4",
    overflow: "hidden",
  },
  image: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "surfaceDim",
    borderBottomWidth: 1,
    borderBottomColor: colors.outline,
    minHeight: 250,
  },
});
